// Professional Healthcare Color Palette
export const colors = {
  // Primary Colors - Professional Medical Teal
  primary: {
    50: '#f0f9fb',
    100: '#e0f2f7',
    200: '#b3dce8',
    300: '#85c6d9',
    400: '#4da8c9',
    500: '#3D8B8B', // Main - Updated to match app/ design
    600: '#2d6b6b', // Dark teal
    700: '#084d5a',
    800: '#053238',
    900: '#021920',
  },

  // Secondary Colors - Healthcare Blue
  secondary: {
    50: '#f0f6ff',
    100: '#e0ecfe',
    200: '#c1d9fc',
    300: '#a2c6fb',
    400: '#5f96f5',
    500: '#1e66f0', // Main
    600: '#1e52d4',
    700: '#1e3eb8',
    800: '#1e2a9c',
    900: '#1e1680',
  },

  // Accent Colors - Professional Orange
  accent: {
    50: '#fff7f0',
    100: '#ffeae0',
    200: '#ffc9b3',
    300: '#ffab87',
    400: '#ff8c5a',
    500: '#ff6e2e', // Main
    600: '#e55a1a',
    700: '#cc4d15',
    800: '#994d1f',
    900: '#663219',
  },

  // Neutral Colors - Professional Grays
  neutral: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },

  // Semantic Colors
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',

  // Background Colors
  background: '#ffffff',
  surface: '#f9fafb',
  border: '#e5e7eb',

  // Text Colors
  text: {
    primary: '#1A2B3C',    // Navy for primary text (from app/)
    secondary: '#6B7A8C',  // Slate for secondary text (from app/)
    tertiary: '#9ca3af',
    inverse: '#ffffff',
  },
};

export default colors;
